import React, { useState } from 'react';
import { UserLocale } from '@teetsh/app/src/types/user';
import { useFormState } from 'react-final-form';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { buildElevesParams } from './Sidebar/buildElevesParams';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import { ElevesPDFSettings } from 'types/eleves';

interface Props {
  viewId: string;
  userId: string;
  lng: UserLocale;
}

export function Body(props: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { viewId, lng } = props;
  const { values: settings } = useFormState<ElevesPDFSettings>();

  const url = new URL(
    `/print/annee-scolaire/${schoolyear.id}/ecole/${school.id}/eleves-views/${viewId}`,
    window.location.origin,
  );

  url.search = buildElevesParams({
    lng,
    settings,
  }).toString();

  const [urlAsString] = useState(url.toString());

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildElevesParams({
      lng,
      settings,
    }),
  });

  return (
    <IframePreviewPDF
      iframeUrl={urlAsString}
      iframeRef={iframeRef}
      landscape={settings.landscape}
    />
  );
}
